import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const NewLoansPage = ({ startDate, endDate }) => {
  const [collections, setCollections] = useState([]);
  const [filteredCollections, setFilteredCollections] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [grandTotal, setGrandTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");
        const response = await axios.get(`${baseURL}/getAllLoan`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setCollections(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCollections();
  }, []);

  useEffect(() => {
    const start = new Date(formatDate(startDate));
    const end = new Date(formatDate(endDate));

    const filtered = collections.filter((collection) => {
      const collectionDate = new Date(collection.start_date);
      return collectionDate >= start && collectionDate <= end;
    });

    setFilteredCollections(filtered);

    const total = filtered.reduce(
      (acc, item) => acc + parseFloat(item.amount || 0),
      0
    );
    setGrandTotal(total);
  }, [startDate, endDate, collections]);

  const formatDateAndDay = (dateString) => {
    const dateObj = new Date(dateString);
    const formattedDate = dateObj
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");
    const dayOfWeek = dateObj.toLocaleDateString("en-US", { weekday: "long" });
    return { formattedDate, dayOfWeek };
  };
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading…</p>
      </div>
    );
  }

  return (
    <div className="p-5 bg-gray-50">
      <h2 className="text-lg font-bold mb-5 text-center">New Loans</h2>
      <h3 className="text-lg font-bold mb-3 text-center">
        {startDate} - {endDate}
      </h3>

      {filteredCollections.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="table-auto w-full border-collapse border border-gray-300 bg-white shadow-md rounded-lg">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-gray-300 px-4 py-2 w-20 text-left">
                  S.No
                </th>
                <th className="border border-gray-300 px-4 py-2 w-25 text-left">
                  Date
                </th>
                <th className="border border-gray-300 px-4 py-2 w-20 text-left">
                  Customer
                </th>
                <th className="border border-gray-300 px-4 py-2 w-20 text-left">
                  Amount
                </th>
                <th className="border border-gray-300 px-4 py-2 w-20 text-left">
                  Scheme
                </th>
                <th className="border border-gray-300 px-4 py-2 w-20 text-left">
                  Mobile No.
                </th>
                <th className="border border-gray-300 px-4 py-2 w-20 text-left">
                  Agent
                </th>
                <th className="border border-gray-300 px-4 py-2 w-20 text-left">
                  Profit
                </th>
                <th className="border border-gray-300 px-4 py-2 w-40 text-left">
                  Total Profit
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredCollections
                .reduce((acc, item, idx) => {
                  const currentProfit = parseFloat(item.initial_profit || 0);
                  const currentAmount = parseFloat(item.amount || 0);

                  const cumulativeProfit =
                    (acc[idx - 1]?.cumulativeProfit || 0) + currentProfit;

                  acc.push({
                    ...item,
                    cumulativeProfit,
                  });

                  return acc;
                }, [])
                .map((item, idx) => (
                  <tr
                    key={item.id}
                    className={`${
                      idx % 2 === 0 ? "bg-white" : "bg-gray-100"
                    } border-b border-gray-200`}
                  >
                    <td className="border border-gray-300 px-4 py-2 w-20">
                      {idx + 1}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 w-30">
                      {formatDate(item.start_date)}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 w-20">
                      {item.tamilname || "N/A"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 w-20">
                      {item.amount}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 w-20">
                      {item.scheme_name || "N/A"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 w-20">
                      {item.contactno}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 w-20">
                      {item.collectionagent_name}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 w-20">
                      {item.initial_profit}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 w-20">
                      {item.cumulativeProfit.toFixed(2)}
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr className="bg-gray-200 font-bold">
                <td colSpan="3" className="py-2 px-4 text-right">
                  Total:
                </td>
                <td className="py-2 px-4">
                  ₹
                  {filteredCollections
                    .reduce(
                      (acc, item) => acc + parseFloat(item.amount || 0),
                      0
                    )
                    .toFixed(2)}
                </td>
                <td colSpan="4"></td>
                <td className="py-2 px-4">
                  ₹
                  {filteredCollections
                    .reduce(
                      (acc, item) => acc + parseFloat(item.initial_profit || 0),
                      0
                    )
                    .toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      ) : (
        <div className="text-center py-4 text-gray-500">
          No data available for the selected date range.
        </div>
      )}
    </div>
  );
};

export default NewLoansPage;
